/* 130R — mega menu da faixa preta do computador (snippets/header-desktop-style.liquid, [data-r130-nav]).
   - Mouse: abre depois de 220 ms parado em cima do item e fecha 250 ms depois de sair (não abre por acidente
     ao cruzar a faixa nem fecha ao descer em diagonal para o painel).
   - Clique/toque e teclado: Enter ou Espaço no botão abre e fecha na hora; Seta para baixo abre e vai ao 1º link;
     Esc fecha e volta ao botão; sair do item com Tab fecha. O botão mantém aria-expanded atualizado.
   - O header do computador entra na página depois (template + evento desktop-lazyloaded), por isso os eventos
     ficam no document (delegação) e funcionam com o header inserido a qualquer momento. */
(function () {
  'use strict';
  var ABRIR_MS = 220, FECHAR_MS = 250;
  var aberto = null;      // <li> com o painel aberto
  var timer = null;
  var pendente = null;    // <li> esperando o tempo de abrir

  function item(el) { return el && el.closest ? el.closest('[data-r130-nav] .r130-nav__item') : null; }
  function gatilho(li) { return li && li.querySelector('[data-r130-mega-gatilho]'); }
  function painel(li) { return li && li.querySelector('[data-r130-mega]'); }
  function limpar() { if (timer) { clearTimeout(timer); timer = null; } pendente = null; }

  function fechar(li, devolverFoco) {
    var b = gatilho(li), p = painel(li);
    if (!b || !p) return;
    b.setAttribute('aria-expanded', 'false');
    p.hidden = true;
    if (aberto === li) aberto = null;
    if (devolverFoco) b.focus();
  }
  function abrir(li) {
    var b = gatilho(li), p = painel(li);
    if (!b || !p) return;
    if (aberto && aberto !== li) fechar(aberto);
    b.setAttribute('aria-expanded', 'true');
    p.hidden = false;
    aberto = li;
  }
  function primeiroLink(li) { var p = painel(li); return p && p.querySelector('a[href], button:not([disabled])'); }

  // As fotos dos painéis ficam em loading="lazy" (não pesam na página); no 1º contato com a faixa, já começam a carregar.
  var fotosPedidas = false;
  function pedirFotos(ev) {
    if (fotosPedidas || !ev.target.closest || !ev.target.closest('[data-r130-nav]')) return;
    fotosPedidas = true;
    document.querySelectorAll('[data-r130-mega] img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }
  document.addEventListener('pointerover', pedirFotos);
  document.addEventListener('focusin', pedirFotos);

  /* ----- mouse (só ponteiro de mouse; toque usa o clique) ----- */
  document.addEventListener('pointerover', function (ev) {
    if (ev.pointerType && ev.pointerType !== 'mouse') return;
    var li = item(ev.target);
    if (!li) return;
    if (li === aberto) { limpar(); return; }
    if (!gatilho(li)) {               // item sem painel (Kits, Marcas...): fecha o aberto sem pressa
      if (aberto) { limpar(); var a = aberto; timer = setTimeout(function () { fechar(a); }, FECHAR_MS); }
      return;
    }
    if (li === pendente) return;     // já contando o tempo para este item
    limpar();
    pendente = li;
    timer = setTimeout(function () { pendente = null; timer = null; abrir(li); }, ABRIR_MS);
  });
  document.addEventListener('pointerout', function (ev) {
    if (ev.pointerType && ev.pointerType !== 'mouse') return;
    var li = item(ev.target);
    if (!li || li.contains(ev.relatedTarget)) return;   // ainda dentro do item (botão ou painel)
    limpar();
    if (li === aberto) timer = setTimeout(function () { fechar(li); }, FECHAR_MS);
  });

  /* ----- clique e toque ----- */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-r130-nav] [data-r130-mega-gatilho]');
    if (b) {
      var li = item(b);
      limpar();
      if (b.getAttribute('aria-expanded') === 'true') fechar(li); else abrir(li);
      return;
    }
    if (aberto && !aberto.contains(ev.target)) fechar(aberto);   // clique fora fecha
  });

  /* ----- teclado ----- */
  document.addEventListener('keydown', function (ev) {
    var li = item(ev.target);
    if (ev.key === 'Escape' && aberto) {
      var foco = aberto.contains(document.activeElement);
      fechar(aberto, foco);
      return;
    }
    if (!li) return;
    var b = gatilho(li);
    if (ev.key === 'ArrowDown' && b && ev.target === b) {
      ev.preventDefault();
      limpar();
      abrir(li);
      var l = primeiroLink(li);
      if (l) l.focus();
    }
  });
  document.addEventListener('focusout', function (ev) {
    var li = item(ev.target);
    if (!li || li !== aberto) return;
    if (ev.relatedTarget && li.contains(ev.relatedTarget)) return;
    if (!ev.relatedTarget) return;                         // clique em área vazia: o clique fora decide
    fechar(li);
  });

  // Rolar a página com o painel aberto (o menu preto não fica preso no topo) fecha o painel.
  window.addEventListener('scroll', function () {
    if (aberto && window.pageYOffset > 200) fechar(aberto);
  }, { passive: true });
})();
